/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkSendPushNotificationRequest,
  BulkSendPushNotificationResponse,
  ErrorResponse,
  ListPushNotificationCategoriesResponse,
  PushNotificationCategoryResponse,
  RegisterPushNotificationCategoryRequest,
} from '../models/index';
import {
    BulkSendPushNotificationRequestFromJSON,
    BulkSendPushNotificationRequestToJSON,
    BulkSendPushNotificationResponseFromJSON,
    BulkSendPushNotificationResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ListPushNotificationCategoriesResponseFromJSON,
    ListPushNotificationCategoriesResponseToJSON,
    PushNotificationCategoryResponseFromJSON,
    PushNotificationCategoryResponseToJSON,
    RegisterPushNotificationCategoryRequestFromJSON,
    RegisterPushNotificationCategoryRequestToJSON,
} from '../models/index';

export interface ListPushNotificationCategoriesRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface RegisterPushNotificationCategoryOperationRequest {
    customerId: string;
    registerPushNotificationCategoryRequest: RegisterPushNotificationCategoryRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface SendBulkPushNotificationRequest {
    customerId: string;
    bulkSendPushNotificationRequest: BulkSendPushNotificationRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PushNotificationsApi extends runtime.BaseAPI {

    /**
     */
    async listPushNotificationCategoriesRaw(requestParameters: ListPushNotificationCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPushNotificationCategoriesResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPushNotificationCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:push-notifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/push-notifications/categories`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPushNotificationCategoriesResponseFromJSON(jsonValue));
    }

    /**
     */
    async listPushNotificationCategories(requestParameters: ListPushNotificationCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPushNotificationCategoriesResponse> {
        const response = await this.listPushNotificationCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerPushNotificationCategoryRaw(requestParameters: RegisterPushNotificationCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushNotificationCategoryResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling registerPushNotificationCategory().'
            );
        }

        if (requestParameters['registerPushNotificationCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'registerPushNotificationCategoryRequest',
                'Required parameter "registerPushNotificationCategoryRequest" was null or undefined when calling registerPushNotificationCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:push-notifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/push-notifications/categories`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterPushNotificationCategoryRequestToJSON(requestParameters['registerPushNotificationCategoryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushNotificationCategoryResponseFromJSON(jsonValue));
    }

    /**
     */
    async registerPushNotificationCategory(requestParameters: RegisterPushNotificationCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushNotificationCategoryResponse> {
        const response = await this.registerPushNotificationCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendBulkPushNotificationRaw(requestParameters: SendBulkPushNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkSendPushNotificationResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling sendBulkPushNotification().'
            );
        }

        if (requestParameters['bulkSendPushNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkSendPushNotificationRequest',
                'Required parameter "bulkSendPushNotificationRequest" was null or undefined when calling sendBulkPushNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:push-notifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/push-notifications/bulk-send`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkSendPushNotificationRequestToJSON(requestParameters['bulkSendPushNotificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkSendPushNotificationResponseFromJSON(jsonValue));
    }

    /**
     */
    async sendBulkPushNotification(requestParameters: SendBulkPushNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkSendPushNotificationResponse> {
        const response = await this.sendBulkPushNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
